import { createSelector } from "reselect";
import { progressValuesSelector } from "../progress_values_selector";

export const progressValuesWithoutHealedSelector = createSelector(
  progressValuesSelector,
  progressValues => {
    return progressValues.filter(progress => progress != "healed");
  }
);
